const ROUTES = {
  // ---- Thirdparties ---- //
  THIRDPARTIES: "thirdparties",
  THIRDPARTY_ADD: "thirdparties/add",
  THIRDPARTY_DETAIL: "thirdparties/:thirdpartyId",
  THIRDPARTY_DOSSIER_DETAIL: "thirdparties/:thirdpartyId/dossiers/:dossierId",
  THIRDPARTY_DOCUMENT_DETAIL: "thirdparties/:thirdpartyId/documents/:reponseId",
  THIRDPARTY_DOSSIER_DOCUMENT_DETAIL: "thirdparties/:thirdpartyId/dossiers/:dossierId/documents/:reponseId",
  TP_ADD_DOSSIER: "thirdparties/:thirdpartyId/dossiers/add",
  // ---- Dossiers ---- //
  DOSSIERS: "dossiers",
  DOSSIER_DETAIL: "dossiers/:dossierId",
  DOSSIER_DOCUMENT_DETAIL: "dossiers/:dossierId/documents/:reponseId",
  // ---- Documents ---- //
  DOCUMENTS: "documents",
  DOCUMENT_DETAIL: "documents/:reponseId",
  // ---- Archives ---- //
  ARCHIVES: {
    DOSSIERS: "archives/dossiers",
    DOSSIER_DETAIL: "archives/dossiers/:dossierId",
    THIRDPARTIES: "archives/thirdparties",
    THIRDPARTY_DETAIL: "archives/thirdparties/:thirdpartyId",
    THIRDPARTY_DOSSIER_DETAIL: "archives/thirdparties/:thirdpartyId/dossiers/:dossierId",
    THIRDPARTY_DOSSIER_DOCUMENT_DETAIL: "archives/thirdparties/:thirdpartyId/dossiers/:dossierId/documents/:reponseId",
    DOSSIER_DOCUMENT_DETAIL: "archives/dossiers/:dossierId/documents/:reponseId",
    CONTEXTS: 'archives/context'
  },
  // ---- Contextes ---- //
  CONTEXT: "context",
  ADD_CONTEXT: "context/add",
  TP_SHEET_ADD_TP: "context/addtpsheet",
  CONTEXT_DETAIL_ADD_TP: "context/addtp",
  // ---- Others ---- //
  DEFAULT: "",
  DASHBOARD: "dashboard",
  ANSWER: "answer",
  ADMIN: "admin",
  ADMIN_EMBEDDABLE: "admin-embeddable",
  USERS: "users",
  PROFILE: "profile",
  NO_ACCOUNT: "noaccount",
  ACCOUNT_SUSPENDED: "account-suspended",
  ROLES: "roles",
  EVENTS: "events",
  ROADMAP: "roadmap",
  REPORTS: "reports",
  ICONS_VIEWER: "fht6h51d3xg51xdr3g51dx3rg5ws1g3rw5d1hb3wdrhb51wdr3gv5wdr1g",
  LIGHT_LAUNCH: "light/launch",
  LIGHT_EVALUATIONS: "light/evaluations",
  LIGHT_DOSSIER_DETAIL: "light/dossiers/:dossierId",
  LIGHT_CONSUMPTION: "light/consumption",
  LIGHT_ACCOUNT: "light/account",
  LIGHT_THIRDPARTIES: "light/thirdparties",
  LIGHT_THIRDPARTY_DETAIL: "light/thirdparties/:thirdpartyId",
  LIGHT_CONTEXTS: "light/contexts",
  LIGHT_CONTEXT_DETAIL: "light/contexts/:contextId"
};

export const getUrlWithAccountId = (accountId, path) => `/${accountId}/${path}`

export default ROUTES;
